export var AudioTranscriptDelta;
(function (AudioTranscriptDelta) {
    /**
     * Type of delta event.
     */
    let type;
    (function (type) {
        type["AUDIO_TRANSCRIPT_DELTA"] = "audio_transcript_delta";
    })(type = AudioTranscriptDelta.type || (AudioTranscriptDelta.type = {}));
})(AudioTranscriptDelta || (AudioTranscriptDelta = {}));
